import { render } from "./BlankLayout.vue?vue&type=template&id=dc9f18b4&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"

import "./BlankLayout.vue?vue&type=style&index=0&id=dc9f18b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9f18b4"]])

export default __exports__